import { Component, OnInit, OnDestroy, AfterContentChecked, Input } from '@angular/core';
import EmblaCarousel from 'embla-carousel';
import { onThumbClick, followMainCarousel } from '../../thumbButton';
import { Lightbox } from '../../../components/lightbox';
import * as _ from 'lodash';

@Component({
  selector: 'app-embla-carousel',
  templateUrl: './embla-carousel.component.html',
  styleUrls: ['./embla-carousel.component.scss']
})
export class EmblaCarouselComponent implements OnInit, OnDestroy, AfterContentChecked {

  _localFileList: any[] = [];
  _tencentFileList: any[] = [];
  mainCarousel: any;
  thumbCarousel: any;
  isSpinning = false;
  isInit = true;
  isShowVideoModal = false;
  videoInfo = null;
  @Input()
  set localFileList(v) {
    this.isSpinning = true;
    this._localFileList = v;
  }

  get localFileList() {
    return this._localFileList;
  }

  @Input()
  set tencentFileList(v) {
    this._tencentFileList = v;
    this.isSpinning = true;
  }

  get tencentFileList() {
    return this._tencentFileList;
  }

  @Input() fileListLength: number;
  constructor(
    private _lightbox: Lightbox
  ) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
  }

  ngAfterContentChecked() {
    const thumbs = document.querySelectorAll('.embla__slide--thumb');
    if (this.isInit && thumbs.length === this.fileListLength) {
      this.handleCarousel();
    }
  }

  handleCarousel() {
    const rootNode = document.querySelector('.embla');
    const mainCarouselWrap = document.getElementById('main-carousel') as HTMLElement;
    const mainCarouselView = mainCarouselWrap.querySelector('.embla__viewport') as HTMLElement;
    this.mainCarousel = EmblaCarousel(mainCarouselView, {
      selectedClass: '',
      loop: true
    });
    const prevButtonNode = rootNode.querySelector('.embla__button--prev');
    const nextButtonNode = rootNode.querySelector('.embla__button--next');
    prevButtonNode.addEventListener('click', this.mainCarousel.scrollPrev, false);
    nextButtonNode.addEventListener('click', this.mainCarousel.scrollNext, false);
    const thumbCarouselWrap = document.getElementById('thumb-carousel') as HTMLElement;
    const thumbCarouselView = thumbCarouselWrap.querySelector('.embla__viewport') as HTMLElement;
    this.thumbCarousel = EmblaCarousel(thumbCarouselView, {
      selectedClass: '',
      containScroll: 'keepSnaps',
      loop: true
    });
    this.thumbCarousel.slideNodes().forEach((thumbNode, index) => {
      const onClick = onThumbClick(this.mainCarousel, this.thumbCarousel, index);
      thumbNode.addEventListener('click', onClick, false);
    });

    const syncThumbCarousel = followMainCarousel(this.mainCarousel, this.thumbCarousel);
    this.mainCarousel.on('select', syncThumbCarousel);
    this.thumbCarousel.on('init', syncThumbCarousel);
    this.isInit = false;
    this.isSpinning = false;
  }

  openPreview(index) {
    const imgArr = [...this.localFileList, ...this.tencentFileList];
    const albums = [];
    for (const img of imgArr) {
      albums.push({
        src: img.url,
        caption: img.fileName || '',
        thumb: img.url,
        fileDataType: img.fileDataType,
      });
    }
    this._lightbox.open(albums, index, { showZoom: true, showRotate: true, centerVertically: true });
  }
  openPreviewVideo(file){
    this.isShowVideoModal = true;
    this.videoInfo = file;
  }
  closeVideoModal(){
    this.isShowVideoModal = false;
  }
}
